import { useStyles } from '@wix/tpa-settings/react';
import { useExperiments } from '@wix/yoshi-flow-editor';
import isEqual from 'lodash/isEqual';
import { type CSSProperties } from 'react';

import { EXPERIMENTS } from '../../../constants/experiments';
import stylesParams from '../stylesParams';

const HEADING_OVERRIDES = [
  {
    font: stylesParams.headerOneFont,
    variant: stylesParams.headerOneFontH1,
    cssVar: '--wix-forms-formHeaderOneFont',
  },
  {
    font: stylesParams.headerTwoFont,
    variant: stylesParams.headerTwoFontH2,
    cssVar: '--wix-forms-formHeaderTwoFont',
  },
] as const;

export const useHeadingOverrides = (): CSSProperties => {
  const styles = useStyles();
  const { experiments } = useExperiments();

  if (!experiments.enabled(EXPERIMENTS.ENABLE_HEADING_LEVELS)) {
    return {};
  }

  const overrides: Record<string, string> = {};

  for (const { font, variant, cssVar } of HEADING_OVERRIDES) {
    // Heading 1 is connected to Heading 5 site theme value, and Heading 2 to Heading 6.
    // When isHeadingLevelsEnabled is on, headings should match corresponding theme values
    // (e.g., Heading 1 use Heading 1 theme value) unless they have been customized
    // (disconnected from the theme)
    const fontCurrent = styles.get(font);
    const fontDefault = styles.getDefaultValue(font);
    const isConnectedToTheme = isEqual(fontCurrent, fontDefault);

    const fontValue = styles.get(isConnectedToTheme ? variant : font);

    if (!fontValue) {
      continue;
    }

    overrides[`${cssVar}-size`] = `${fontValue.size}px`;

    if (fontValue.family) {
      overrides[`${cssVar}-family`] = fontValue.family;
    }
  }

  return overrides as unknown as CSSProperties;
};
